// CSS Modules - component class name prefix: Tabs__

<template>
  <div
    :class="[
      { Tabs__vertical: this.isVertical },
      { clearfix: this.isVertical },
      $style.container
    ]"
    :style="{ padding: padding ? padding : '' }"
  >
    <div :class="$style.tabs">
      <a
        v-for="tab in tabCount"
        :key="tab"
        v-on:click="
          !navigateOnClick &&
            !isVertical &&
            disabledTabs.indexOf(tab) < 0 &&
            (activetab = tab)
        "
        :href="navigateOnClick && tabTitles && tabTitles[tab - 1].url"
        v-on:mouseenter="
          isVertical === true &&
            disabledTabs.indexOf(tab) < 0 &&
            (activetab = tab)
        "
        :class="[
          activetab === tab ? 'Tabs__active' : '',
          disabledTabs.indexOf(tab) >= 0 ? 'Tabs__disabled' : '',
          dividerBeforeTab === tab ? 'Tabs__divider' : ''
        ]"
      >
        <slot :name="`${tab}-title`" v-if="!tabTitles"></slot>
        <span v-if="tabTitles" v-html="filteredTitles[tab - 1]"></span>
      </a>
    </div>
    <div :class="$style.tabcontent">
      <div v-for="tab in tabCount" :key="tab">
        <slot :name="`${tab}-content`" v-if="activetab === tab"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    disabledTabs: {
      type: Array,
      default: () => []
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    navigateOnClick: {
      type: Boolean,
      default: false
    },
    tabCount: {
      type: Number,
      default: 1
    },
    padding: {
      type: String,
      default: ""
    },
    dividerBeforeTab: {
      type: Number,
      default: null
    },
    tabTitles: {
      type: Array
    }
  },
  data() {
    return {
      activetab: 1,
      filteredTitles: []
    };
  },
  mounted() {
    if (this.tabTitles && this.tabTitles.length > 0) {
      for (let subElm of this.tabTitles) {
        this.filteredTitles.push(subElm.title);
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./Tabs.scss";
</style>
